import { LAMPORTS_PER_SOL } from '@solana/web3.js';
import { useSolanaLive } from '../../hooks/useSolanaLive';

function formatTimestamp(value) {
  if (!value) {
    return 'Waiting for data';
  }

  return new Date(value).toLocaleString();
}

function formatSolValue(lamports) {
  if (lamports === null) {
    return 'Waiting for data';
  }

  return `${(lamports / LAMPORTS_PER_SOL).toLocaleString(undefined, {
    maximumFractionDigits: 9,
  })} SOL`;
}

function GlobalDumpVaultViewer() {
  const { dumpVault, dumpVaultPubkey, error, lastUpdated, loading, subscribed } = useSolanaLive();
  const lamports = dumpVault?.lamports ?? null;
  const vaultState = dumpVault?.data ?? null;

  return (
    <div className="global-config-viewer">
      <div className="global-config-viewer__metaGrid">
        <div className="surface global-config-viewer__metaCard">
          <span className="label">Dump vault pubkey</span>
          <strong className="global-config-viewer__mono">{dumpVaultPubkey || 'Loading PDA...'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Loading state</span>
          <strong>{loading.dumpVault ? 'Loading' : 'Ready'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Subscribed state</span>
          <strong>{subscribed.dumpVault ? 'Subscribed' : 'Not subscribed'}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Last updated</span>
          <strong>{formatTimestamp(lastUpdated.dumpVault)}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">SOL</span>
          <strong>{formatSolValue(lamports)}</strong>
        </div>

        <div className="surface global-config-viewer__metaCard">
          <span className="label">Raw lamports</span>
          <strong>{lamports === null ? 'Waiting for data' : String(lamports)}</strong>
        </div>
      </div>

      <div className="surface global-config-viewer__jsonCard">
        <div className="global-config-viewer__jsonHeader">
          <div>
            <p className="eyebrow">Decoded Account</p>
            <h2>global_dump_vault JSON</h2>
          </div>
          {error.dumpVault ? <span className="status-pill status-pill--warning">{error.dumpVault}</span> : null}
        </div>

        <pre className="global-config-viewer__json">
          {JSON.stringify(vaultState, null, 2) || 'No global_dump_vault data loaded yet.'}
        </pre>
      </div>
    </div>
  );
}

export default GlobalDumpVaultViewer;
